import { createSelector } from '@reduxjs/toolkit'

export const loadingSelector = state => state.loadingReducer

export const getPathToRedirect = () =>
  createSelector(loadingSelector, loading => loading.path)
